export const ClipboardTick = () => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.54074 6.57599C9.75605 6.71677 9.81647 7.00544 9.67569 7.22075L7.35638 10.7679C7.28173 10.8821 7.1608 10.9578 7.0255 10.9751C6.8902 10.9923 6.75413 10.9494 6.6532 10.8577L5.15247 9.49338C4.96212 9.32034 4.94809 9.02575 5.12114 8.8354C5.29418 8.64505 5.58877 8.63102 5.77912 8.80407L6.87563 9.8009L8.89598 6.71094C9.03676 6.49563 9.32543 6.43521 9.54074 6.57599Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 2.5V1.5H10V2.5H5ZM4.75 0.5C4.33579 0.5 4 0.835786 4 1.25V1.5H3.5C2.67157 1.5 2 2.17157 2 3V13C2 13.8284 2.67157 14.5 3.5 14.5H11.5C12.3284 14.5 13 13.8284 13 13V3C13 2.17157 12.3284 1.5 11.5 1.5H11V1.25C11 0.835786 10.6642 0.5 10.25 0.5H4.75ZM11 2.5V2.75C11 3.16421 10.6642 3.5 10.25 3.5H4.75C4.33579 3.5 4 3.16421 4 2.75V2.5H3.5C3.22386 2.5 3 2.72386 3 3V13C3 13.2761 3.22386 13.5 3.5 13.5H11.5C11.7761 13.5 12 13.2761 12 13V3C12 2.72386 11.7761 2.5 11.5 2.5H11Z"
      fill="currentColor"
    />
  </svg>
);
